import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "progressive-bar" };
import { useStore } from 'vuex';
import { computed, watch } from 'vue';
// vuex
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalProcessProgress',
    setup(__props) {
        // libs
        const store = useStore();
        // actions
        const setIsModalvisible = (isVisible) => store.dispatch('salesReportNew/setIsModalProgressVisible', isVisible);
        const setCancelExportJobDetails = () => store.dispatch('salesReportNew/setCancelExportJobDetails');
        // computed
        const getIsModalVisible = computed(() => store.getters['salesReportNew/getIsModalProgressVisible']);
        const getProgress = computed(() => store.getters['salesReportNew/getProgress']);
        const getUrlFile = computed(() => store.getters['salesReportNew/getUrlFile']);
        // watch
        watch(getProgress, () => {
            if (getProgress.value === 100) {
                setTimeout(() => {
                    window.location.replace(getUrlFile.value);
                    setIsModalvisible(false);
                }, 1000);
            }
        });
        const cancelExportRequest = () => {
            setCancelExportJobDetails();
        };
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: getIsModalVisible.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((getIsModalVisible).value = $event)),
                class: "modal-process-progress",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false
            }, {
                default: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('spinner')), 1),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("span", null, _toDisplayString(getProgress.value) + "%", 1),
                        _createElementVNode("div", null, [
                            _createElementVNode("span", {
                                class: "pb__load",
                                style: _normalizeStyle({ width: getProgress.value + '%' })
                            }, null, 4)
                        ])
                    ]),
                    _createElementVNode("button", {
                        class: "btn btn-outline-ctx-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (cancelExportRequest()))
                    }, _toDisplayString(_ctx.$t('cancel')), 1)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
